import { render, staticRenderFns } from "./tournaments.vue?vue&type=template&id=5ff037a6&"
import script from "./tournaments.vue?vue&type=script&lang=js&"
export * from "./tournaments.vue?vue&type=script&lang=js&"
import style0 from "./tournaments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports